import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikProvider } from 'formik';
import { AppBar, Dialog, DialogActions, DialogContent, Divider, Grid } from '@mui/material';
import { t } from 'i18next';
import { Button } from '~/views/atoms/button';
import { Transition } from '~/views/atoms/transition';
import { DialogTopBar } from '~/views/molecules/dialog-top-bar';
import { useCallback, useMemo } from 'react';
import { useService } from '~/services/service.base';
import { ServiceDateFilter } from '~/services/service.date.filter';
import { plainToModel } from '~/tools/plain.model';
import { useFormikModel } from '~/tools/formik.model';
import { ModelDateFilter } from '~/models/model.date.filter';
import { FormDateFilter } from '~/views/molecules/form-date-filter';
export const DateFilter = ({ years, defaultYear, onSubmitHandler }) => {
    const dateFilterService = useService(ServiceDateFilter);
    const closeButtonHandler = useCallback(() => {
        dateFilterService.openDateFilterService.handleClose();
    }, [dateFilterService.openDateFilterService]);
    const initialValues = useMemo(() => plainToModel(ModelDateFilter, { filterOption: defaultYear }), [defaultYear]);
    const formik = useFormikModel(ModelDateFilter, {
        initialValues,
        onSubmit: onSubmitHandler,
        validateOnMount: true,
        validateOnChange: true,
    });
    return (_jsx(FormikProvider, { value: formik, children: _jsxs(Dialog, { fullWidth: true, open: dateFilterService.openDateFilterService.open, TransitionComponent: Transition, children: [_jsxs(AppBar, { color: "inherit", position: "relative", children: [_jsx(DialogTopBar, { closeButtonHandler: closeButtonHandler, title: t('BOOK_PAGE_FILTER_TITLE') }), _jsx(Divider, {})] }), _jsx(DialogContent, { className: 'without-bottom-padding', children: _jsx(FormDateFilter, { options: years }) }), _jsx(DialogActions, { children: _jsx(Grid, { container: true, flexDirection: "column", children: _jsx(Grid, { item: true, children: _jsx(Button, { fullWidth: true, onClick: formik.submitForm, children: t('MEDIAS_FILTERS_ENREGISTRER') }) }) }) })] }) }));
};
